// Массовая установка в «Установке»: подписи и подсчёты очереди. Сама очередь живёт на сервере
// (midori_install_batch.py): ставит отмеченные подключения по одному и останавливается на сбое установщика.

export const BATCH_STATUS_LABELS = {
  running: 'Идёт',
  completed: 'Дошла до конца',
  stopped: 'Остановлена сбоем',
  cancelled: 'Остановлена',
  failed: 'Прервалась',
};

export const BATCH_STATUS_COLORS = {
  running: 'processing',
  completed: 'success',
  stopped: 'error',
  cancelled: 'default',
  failed: 'error',
};

export const ITEM_STATUS_LABELS = {
  pending: 'ждёт',
  running: 'идёт',
  completed: 'готово',
  partially_completed: 'частично',
  failed: 'с ошибкой',
  cancelled: 'отменена',
  skipped: 'пропущен',
  not_started: 'не начинался',
};

export const ITEM_STATUS_COLORS = {
  pending: 'default',
  running: 'processing',
  completed: 'success',
  partially_completed: 'warning',
  failed: 'error',
  cancelled: 'default',
  skipped: 'warning',
  not_started: 'default',
};

// Сервер, который ставится сейчас: его ход показываем ниже, как одиночную установку.
export const currentBatchJobId = (batch) => {
  const item = (batch?.items || []).find((entry) => entry.status === 'running' && entry.job_id);
  return item ? item.job_id : null;
};

// «готово 3 · с ошибкой 1 · ждёт 2» — сначала итоги, потом то, что ещё впереди.
const SUMMARY_ORDER = [
  'completed', 'partially_completed', 'failed', 'skipped', 'cancelled', 'running', 'pending', 'not_started',
];

export const batchSummary = (batch) => SUMMARY_ORDER
  .filter((status) => batch?.counts?.[status])
  .map((status) => `${ITEM_STATUS_LABELS[status]} ${batch.counts[status]}`)
  .join(' · ');

// Отмеченные — в порядке списка: в нём и пойдёт установка. Без сохранённого SSH не ставится.
export const orderedSelection = (targets, selectedIds) => {
  const chosen = new Set(selectedIds);
  return targets.filter((item) => item.ssh_ready && chosen.has(item.id)).map((item) => item.id);
};

export const serversWord = (count) => {
  const tens = count % 100;
  const ones = count % 10;
  if (tens >= 11 && tens <= 14) return 'серверов';
  if (ones === 1) return 'сервер';
  if (ones >= 2 && ones <= 4) return 'сервера';
  return 'серверов';
};
